/**
 * Single source of truth for platform-owner identity + deployment refs.
 *
 * Never inline these values elsewhere. Consumers should import from here so a
 * future fork/whitelabel only edits one file. See docs/FORK_GUIDE.md.
 */
export const PLATFORM_CONFIG = {
	ownerUserId: '7eb557f9-5f94-4951-805b-d321ed8f7494',
	ownerUsername: 'CardSimp',
	ownerDisplayName: 'CardSimp',
	supabaseProjectRef: 'eospuczempzaeankctcc',
	customDomain: 'cardsimp.com',
	/**
	 * Optional prefix applied to every Storage bucket ID resolved through
	 * `src/lib/storageBuckets.ts`. Empty on canonical CardSimp. A fork that
	 * wants isolated buckets can set e.g. `'myshop-'` — no other file needs
	 * to change (buckets themselves must still be created in the fork's
	 * Supabase project).
	 */
	storageBucketPrefix: '' as string,
} as const;

export type PlatformConfig = typeof PLATFORM_CONFIG;

/** Build a fully-qualified edge function URL for the current deployment. */
export const edgeFunctionUrl = (name: string) =>
	`https://${PLATFORM_CONFIG.supabaseProjectRef}.supabase.co/functions/v1/${name}`;
